/// <amd-module name="Wit/WorkItemForm/Common/Components/FieldName" />
import * as React from "react";
import { useFieldMetadata } from "../Hooks";

export interface IFieldNameProps {
    refName: string;
}

export function FieldName({ refName }: IFieldNameProps) {
    const fieldMetadata = useFieldMetadata(refName);
    return <>{fieldMetadata?.name}</>;
}
